import { exists } from '../runtime.js';
import './ApiActivityType.js';
import './ApiAdditionalInfoType.js';
import './ApiAirportType.js';
import { ApiAvailStateFromJSON, ApiAvailStateToJSON } from './ApiAvailState.js';
import './ApiBaggageType.js';
import './ApiBaggageUnitType.js';
import { ApiBaseDataFromJSON, ApiBaseDataToJSON } from './ApiBaseData.js';
import './ApiBaseDataSource.js';
import './ApiBookingAction.js';
import './ApiBookingState.js';
import './ApiCabinClass.js';
import './ApiCamperFeatureType.js';
import './ApiClientType.js';
import './ApiComponentPriceType.js';
import './ApiComponentType.js';
import './ApiConfigurationDataType.js';
import './ApiDebitType.js';
import './ApiDirection.js';
import './ApiDistanceUnit.js';
import './ApiDocumentSubType.js';
import './ApiDocumentType.js';
import { ApiDurationInfoFromJSON, ApiDurationInfoToJSON } from './ApiDurationInfo.js';
import './ApiDurationType.js';
import './ApiFilterCategory.js';
import './ApiFilterType.js';
import './ApiFuelType.js';
import './ApiGender.js';
import './ApiImageType.js';
import './ApiInventory.js';
import { ApiItemFromJSONTyped, ApiItemToJSON } from './ApiItem.js';
import './ApiItemType.js';
import { ApiMediaFromJSON, ApiMediaToJSON } from './ApiMedia.js';
import { ApiNoteFromJSON, ApiNoteToJSON } from './ApiNote.js';
import './ApiNoteOriginType.js';
import './ApiNoteType.js';
import './ApiPackagePriceComponentType.js';
import './ApiPaymentDataType.js';
import './ApiPaymentOption.js';
import './ApiPaymentState.js';
import './ApiPriceModifierType.js';
import './ApiPriceType.js';
import './ApiRecommendationServiceType.js';
import { ApiRelatedServiceFromJSON, ApiRelatedServiceToJSON } from './ApiRelatedService.js';
import './ApiRelatedServiceRelationType.js';
import './ApiRole.js';
import { ApiRoomRateFromJSON, ApiRoomRateToJSON } from './ApiRoomRate.js';
import './ApiRowCharacteristics.js';
import './ApiSeatCharacteristics.js';
import './ApiServiceSelectionType.js';
import './ApiSortDirection.js';
import './ApiSortOption.js';
import './ApiSpecialRequestGroup.js';
import './ApiStaticContentType.js';
import './ApiTaxDisplay.js';
import './ApiTransmissionType.js';
import './ApiTravelStatusEnum.js';
import './ApiTravelerType.js';
import './ApiVoucherDeliveryType.js';
import './ApiWalletType.js';

/* tslint:disable */
function ApiHotelRoomFromJSON(json) {
    return ApiHotelRoomFromJSONTyped(json, false);
}
function ApiHotelRoomFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...ApiItemFromJSONTyped(json, ignoreDiscriminator),
        'roomCode': json['roomCode'],
        'cmsCode': json['cmsCode'],
        'themeCode': !exists(json, 'themeCode') ? undefined : json['themeCode'],
        'defaultOccupancy': !exists(json, 'defaultOccupancy') ? undefined : json['defaultOccupancy'],
        'minOccupancy': json['minOccupancy'],
        'maxOccupancy': json['maxOccupancy'],
        'maxAddChild': !exists(json, 'maxAddChild') ? undefined : json['maxAddChild'],
        'maxAddChildAge': !exists(json, 'maxAddChildAge') ? undefined : json['maxAddChildAge'],
        'maxAddInfant': !exists(json, 'maxAddInfant') ? undefined : json['maxAddInfant'],
        'maxAddInfantAge': !exists(json, 'maxAddInfantAge') ? undefined : json['maxAddInfantAge'],
        'media': ApiMediaFromJSON(json['media']),
        'availability': json['availability'],
        'availState': !exists(json, 'availState') ? undefined : ApiAvailStateFromJSON(json['availState']),
        'durationInfo': ApiDurationInfoFromJSON(json['durationInfo']),
        'characteristics': (json['characteristics'].map(ApiBaseDataFromJSON)),
        'roomrates': (json['roomrates'].map(ApiRoomRateFromJSON)),
        'notes': (json['notes'].map(ApiNoteFromJSON)),
        'relatedServices': !exists(json, 'relatedServices') ? undefined : (json['relatedServices'].map(ApiRelatedServiceFromJSON)),
    };
}
function ApiHotelRoomToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...ApiItemToJSON(value),
        'roomCode': value.roomCode,
        'cmsCode': value.cmsCode,
        'themeCode': value.themeCode,
        'defaultOccupancy': value.defaultOccupancy,
        'minOccupancy': value.minOccupancy,
        'maxOccupancy': value.maxOccupancy,
        'maxAddChild': value.maxAddChild,
        'maxAddChildAge': value.maxAddChildAge,
        'maxAddInfant': value.maxAddInfant,
        'maxAddInfantAge': value.maxAddInfantAge,
        'media': ApiMediaToJSON(value.media),
        'availability': value.availability,
        'availState': ApiAvailStateToJSON(value.availState),
        'durationInfo': ApiDurationInfoToJSON(value.durationInfo),
        'characteristics': (value.characteristics.map(ApiBaseDataToJSON)),
        'roomrates': (value.roomrates.map(ApiRoomRateToJSON)),
        'notes': (value.notes.map(ApiNoteToJSON)),
        'relatedServices': value.relatedServices === undefined ? undefined : (value.relatedServices.map(ApiRelatedServiceToJSON)),
    };
}

export { ApiHotelRoomFromJSON, ApiHotelRoomFromJSONTyped, ApiHotelRoomToJSON };
//# sourceMappingURL=ApiHotelRoom.js.map
